import React from 'react';

/**
 * Barra superiore onesta: niente timer o contatori finti e MAI il prezzo (regola Tomás 2026-10-23).
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-[#1E2B58] text-stone-50" data-id="element-59" data-mp="306k0ohz7h96a">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-1.5 whitespace-nowrap px-3 sm:gap-x-3 sm:px-4 py-2.5 text-[11px] min-[380px]:text-xs sm:text-sm" data-id="element-60" data-mp="2vcz2opxm4f73">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-61" data-mp="2mf6ppsfd5jmv">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#F2B134]" data-id="element-62" data-mp="2hf0z8fkty36d" />
        </span>
        <span className="font-semibold text-stone-50" data-id="element-63" data-mp="2cfftnmb5mwko">Pagamento unico</span>
        <span className="text-stone-50/80" data-id="element-64" data-mp="28evvcfeuhmwy">· Accesso immediato · Garanzia 7 giorni</span>
      </div>
    </div>;
}